import { SignConsentFormArgs } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../backend/functions'

export const signConsentForm = httpsCallable<SignConsentFormArgs>(functions, 'signConsentForm')
